import React from "react";
import { withTranslation } from "react-i18next";
import { compose } from "recompose";

import Page from "../../../components/display/Page";
import OpportunitiesList from "../../../components/opportunity/List";
import Header from "../../../components/Header";
import NewOpportunityBtn from "../../../components/NewOpportunityBtn";
import TransparentContainer from "../../../components/display/TransparentContent";

const Opportunities = ({ t, team, canCreate }) => (
  <Page>
    <TransparentContainer>
      <Header title={`${t("global:opportunities")}`}>
        <NewOpportunityBtn canCreate={canCreate} team={team} />
      </Header>
      <OpportunitiesList team={team.id} />
    </TransparentContainer>
  </Page>
);

export default compose(withTranslation(["opportunities", "team", "global"]))(
  Opportunities
);
